<!-- Card Template for custom-table -->
<ng-template
	#companyCard
	let-row>
	<div class="eif-card">
		<div class="eif-card-header">
			<div
				[eifTooltip]="row?.Company?.Name"
				class="truncate">
				<div class="truncate is-bold">
					{{ row?.Company?.Name }}
				</div>
				<span> {{ row?.Company?.CountryCode }} {{ row?.Company?.VatNumber }} </span>
			</div>
		</div>
		<div class="eif-card-section company-logo-section">
			<img
				[src]="getCompanyLogoUrl(row)"
				alt="company-logo"
				class="company-logo" />
		</div>
		@if (row?.CompanyCardDetails?.CompanyCardType !== 'connectedCompanyCard') {
			<div class="tags-container pb-4">
				@if (!!row?.CompanyCardDetails?.IsFinancier) {
					<span class="tag-profiles">
						{{ 'search-companies.list.IsFinancier' | translate }}
					</span>
				}
				@if (!!row?.CompanyCardDetails?.IsBuyer) {
					<span class="tag-profiles">
						{{ 'search-companies.list.IsBuyer' | translate }}
					</span>
				}
				@if (!!row?.CompanyCardDetails?.IsSupplier) {
					<span class="tag-profiles">
						{{ 'search-companies.list.IsSupplier' | translate }}
					</span>
				}
			</div>
		}

		@if (hasFooterActions(row)) {
			<div class="eif-card-section card-actions">
				<!-- Relations -->
				@if (userCanSeeCompanyRelations(row)) {
					<eif-custom-button
						[variant]="['icon', 'text']"
						[preIcon]="'fa-light fa-chart-network'"
						[tooltip]="'company.card.manage.relations' | translate"
						[size]="'x-large'"
						[routerLink]="['/private/company/relations', row?.Company?.Id]">
					</eif-custom-button>
				}
				<!-- Users -->
				@if (userCanSeeCompanyUsers(row)) {
					<eif-custom-button
						[variant]="['icon', 'text']"
						[preIcon]="'fa-light fa-users-class'"
						[tooltip]="'search-companies.users' | translate"
						[size]="'x-large'"
						[routerLink]="['/private/company', row?.Company?.Id, 'users']">
					</eif-custom-button>
				}
				<!-- Details -->
				@if (userCanViewCompanyInformation(row)) {
					<eif-custom-button
						[variant]="['icon', 'text']"
						[preIcon]="'fa-light fa-ellipsis-h-alt'"
						[tooltip]="'company.card-company-details' | translate"
						[size]="'x-large'"
						[routerLink]="['/private/company/details', row?.Company?.Id]">
					</eif-custom-button>
				}
				<!-- Contracts -->
				@if (userCanAccessContracts()) {
					<eif-custom-button
						[variant]="['icon', 'text']"
						[preIcon]="'fa-light fa-file-contract'"
						[tooltip]="'search-companies.view.contracts' | translate"
						[size]="'x-large'"
						[routerLink]="['/private/contracts/search', row?.Company?.Id]">
					</eif-custom-button>
				}
			</div>
		}
	</div>
</ng-template>

<div
	class="simple-card ps-3 pe-3"
	[ngClass]="class">
	<eif-custom-table
		[columns]="tableColumns"
		[rows]="companiesCards"
		[loading]="isTableLoading"
		[pagination]="tablePagination"
		[filters]="tableFilters"
		[enableFilters]="true"
		[idField]="'Company.Id'"
		[identifier]="'search-companies-' + companyUniverseSearch"
		[pathPattern]="'/private/companies'"
		[selectionMode]="'none'"
		[cardViewOnly]="true"
		[export]="tableExport"
		(searchRequested)="onSearchRequested($event)"
		[cardTemplate]="companyCard"
		#customTable>
	</eif-custom-table>
</div>
